<template>
  <div class="search-history">
    <template v-if="historyList.length > 0">
      <div class="search-history-title">
        <div class="flex-1">搜索历史</div>

        <span class="search-history-clear" @click="handleClear">
          清除
        </span>
      </div>
      <ul class="search-history-list">
        <li
          class="search-history-item"
          v-for="item in historyList"
          :key="item"
          @click="handleItemClick('historyrecord', item)">
          <lr-link
            class="ellipsis"
            :to="getSearchUrl(item)"
            :data-keyword="item"
            >{{ item }}</lr-link
          >
        </li>
      </ul>
    </template>

    <div class="search-history-hot" v-if="hotwordList.length > 0">
      <div class="search-history-title">搜索建议</div>
      <div class="search-history-hot-list" :class="hotListClass">
        <lr-link
          class="search-history-hot-item"
          :style="hotItemStyle"
          :to="item.url || getSearchUrl(item.title)"
          v-for="item in hotwordList"
          :key="item.title"
          :data-keyword="item.title"
          @click="handleItemClick('recommendkeyword', item.title)"
          >{{ item.title }}</lr-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getSearchUrl } from '@/common/utils';

export default {
  props: {
    hotwordList: {
      type: Array,
      default: () => [],
    },
    historyList: {
      type: Array,
      default: () => [],
    },
    splitCol: { // 需要分几列展示
      type: Number,
      default: 1
    }
  },

  computed: {
    hotItemStyle() {
      if (this.splitCol > 1) {
        return {
          // width: (100 / this.splitCol) + '%',
          width: '255px'
        }
      }
      return {}
    },
    hotListClass() {
      return {
        'list-flex-row': this.splitCol > 1
      }
    }
  },

  methods: {
    getSearchUrl,

    handleDel(word) {
      this.$collect.homepageSearchClick({ action: 'delete' });
      this.$emit('del-history', word);
    },

    handleClear() {
      this.$collect.homepageSearchClick({ action: 'clearall' });
      this.$emit('clear-history');
    },

    handleItemClick(action, keyword) {
      this.$collect.homepageSearchClick({ action, keyword });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-history {
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  border: 1px solid #D0D3D8;
  padding: 15px 20px;
  background: #fff;
  width: 100%;

  &-title {
    display: flex;
    margin-bottom: 8px;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 12px;
    line-height: 20px;
    color: #9199A5;
  }

  &-clear {
    @include flex-align-center();
    cursor: pointer;
    color: #9199A5;
    font-size: 12px;

    &:hover {
      color: #5794FF;
    }
    &:active:not(:disabled) {
      color: #1C53D4;
    }

    > .icon {
      font-size: 14px;
      margin-right: 4px;
    }
  }

  &-list {
    display: flex;
    flex-flow: row wrap;
  }

  &-item {
    @include flex-align-center();
    position: relative;
    list-style: none;
    line-height: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 1px solid #D0D3D8;
    font-size: 12px;
    margin-right: 10px;
    margin-bottom: 10px;

    > a {
      max-width: 84px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #333840;
      line-height: 20px;
      padding: 3px 10px;
    }

    &-close {
      font-size: 10px;
      display: none;
      margin-left: 5px;

      @include close-btn-style();
    }

    &:hover {
      background: rgba(8, 48, 93, 0.04);

      .search-history-item-close {
        display: block;
      }
    }

    &:active {
      background: rgba(8, 48, 93, 0.08);
    }
  }

  &-hot {
    margin-top: 5px;
  }

  &-hot-list {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    &.list-flex-row {
      flex-flow: row wrap;
      justify-content: space-between;
    }
  }
  &-hot-item {
    margin-bottom: 2px;
    padding: 6px 8px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 20px;
    color: #333840;
    background: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      background: rgba(8, 48, 93, 0.04);
    }
    &:active {
      background: rgba(8, 48, 93, 0.08);
    }
  }
}
</style>
